/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetLocalePreferenceRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/set_locale_preference.pb'
import {SetLocalePreferenceResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/set_locale_preference.pb'


export const setLocalePreference = (request: SetLocalePreferenceRequest, options?: CashRequestOptions) => post<SetLocalePreferenceRequest, SetLocalePreferenceResponse>("/2.0/cash/set-locale-preference", request, {...options, rejectOnError: true })